// @ts-strict-ignore
import React, { useContext, useState } from 'react';
import { Card } from '@usealloy/component-library';
import { ApplicationTypesMap } from '@usealloy/typegen';

import { UserContext } from '~/dashboard/context';
import DiligenceData from '~/entities/evaluations/DiligenceData/DiligenceData';

import { hasDiligenceDataExcludingWatchlist } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { useEventTypeEvaluationsContext } from '../context';

const Diligence: React.FC = () => {
  const { featureFlags } = useContext(UserContext);
  const { evaluation, constructWatchlistMatchDataObject } = useEventTypeEvaluationsContext();

  const isWorkflowTypeJourneyRouter = evaluation.evaluation_type === ApplicationTypesMap
    .JOURNEY_ROUTER;
  const isWorkflowTypeReconciliation = evaluation.evaluation_type === ApplicationTypesMap
    .RECONCILIATION;
  const hideEmptyCardsEnabled = Boolean(featureFlags?.removeEmptyCards);

  const [matchInfo] = useState(constructWatchlistMatchDataObject(
    evaluation.final_response,
  ));

  // Show Diligence if:
  // - Has diligence response data
  // - Not a journey router or reconciliation workflow
  // - Watchlist tab is NOT enabled (if enabled, watchlist is in its own tab, hide Diligence)
  // - Card has non-watchlist data (or remove-empty-cards flag is off)
  const shouldShowDiligence = (
    evaluation.final_response
    && evaluation.final_response.diligence
    && !isWorkflowTypeJourneyRouter
    && !isWorkflowTypeReconciliation
    && shouldRenderCard(hasDiligenceDataExcludingWatchlist(evaluation), hideEmptyCardsEnabled)
  );

  if (!shouldShowDiligence) {
    return null;
  }

  return (
    <Card
      header="Diligence"
      collapsible
    >
      <DiligenceData
        containsWatchlistMatch={matchInfo.length > 0}
        hideEmptyCardsEnabled={hideEmptyCardsEnabled}
        hideFinancial={featureFlags?.['credit-panel']}
        response={evaluation.final_response}
        evaluationToken={evaluation.evaluation_token}
      />
    </Card>
  );
};

export default Diligence;
